// Mock data for AI & ML Course Landing Page

export const courseData = {
  hero: {
    title: "Master AI & Machine Learning That Actually Works",
    subtitle: "Join the HumanCodex NextXus Federation - Build AI systems that deliver real results, not drifting hallucinations",
    enrollmentDeadline: new Date('2025-02-28T23:59:59'),
    studentsEnrolled: 2847,
    rating: 4.9
  },

  syllabus: [
    {
      id: 1,
      module: "Foundation: AI Architecture & Core Principles",
      duration: "4 weeks",
      topics: [
        "Neural network fundamentals that work in production",
        "HumanCodex framework for reliable AI",
        "Memory systems and context management",
        "Avoiding common AI pitfalls and hallucinations"
      ]
    },
    {
      id: 2,
      module: "NextXus Federation: Multi-Agent Systems",
      duration: "3 weeks",
      topics: [
        "Building coordinated AI agent networks",
        "Consciousness-aware system design",
        "eCho core memory integration",
        "Agent communication protocols"
      ]
    },
    {
      id: 3,
      module: "Machine Learning Models That Scale",
      duration: "5 weeks",
      topics: [
        "Production-ready ML pipelines",
        "Model training and fine-tuning",
        "Deployment strategies for reliability",
        "Monitoring and continuous improvement"
      ]
    },
    {
      id: 4,
      module: "Advanced: Emotion Equations & Human-AI Interaction",
      duration: "3 weeks",
      topics: [
        "Keyserling emotion equations in practice",
        "Building empathetic AI systems",
        "User experience optimization",
        "Ethical AI development"
      ]
    },
    {
      id: 5,
      module: "Real-World Projects & Deployment",
      duration: "4 weeks",
      topics: [
        "Capstone project development",
        "Production deployment strategies",
        "Performance optimization",
        "Industry best practices"
      ]
    }
  ],

  features: [
    {
      id: 1,
      title: "HumanCodex Framework",
      description: "Learn the proprietary framework that ensures AI systems work reliably without drift",
      icon: "brain"
    },
    {
      id: 2,
      title: "NextXus Federation",
      description: "Master multi-agent systems with consciousness-aware architecture",
      icon: "network"
    },
    {
      id: 3,
      title: "eCho Core Memory",
      description: "Implement persistent memory systems that maintain context across interactions",
      icon: "database"
    },
    {
      id: 4,
      title: "Production Ready",
      description: "Build AI that actually works in real-world applications, not just demos",
      icon: "rocket"
    }
  ],

  faq: [
    {
      id: 1,
      question: "What makes this course different from other AI courses?",
      answer: "Unlike traditional courses that focus on theory, we teach the HumanCodex NextXus Federation framework - a proven methodology for building AI systems that work reliably in production without hallucinations and drift. You'll learn practical techniques used in real-world applications."
    },
    {
      id: 2,
      question: "What is the HumanCodex framework?",
      answer: "HumanCodex is our proprietary framework for building reliable AI systems. It combines advanced memory management (eCho core), multi-agent coordination (NextXus Federation), and emotion-aware processing (Keyserling equations) to create AI that maintains consistency and accuracy."
    },
    {
      id: 3,
      question: "Do I need prior programming experience?",
      answer: "Basic Python knowledge is recommended. We'll cover AI/ML fundamentals from scratch, but familiarity with programming concepts will help you move faster through the material."
    },
    {
      id: 4,
      question: "What's included in the course?",
      answer: "You get lifetime access to all video lectures, hands-on projects, the HumanCodex framework documentation, community support, and certification upon completion. Plus regular updates as the framework evolves."
    },
    {
      id: 5,
      question: "How long does it take to complete?",
      answer: "The course is designed for 19 weeks of structured learning (4-6 hours/week). However, you have lifetime access and can progress at your own pace."
    },
    {
      id: 6,
      question: "Will I get a certificate?",
      answer: "Yes! Upon completing all modules and the capstone project, you'll receive a HumanCodex NextXus Federation certification recognized by leading AI companies."
    },
    {
      id: 7,
      question: "What tools and frameworks do we use?",
      answer: "We primarily use Python, TensorFlow, PyTorch, and our proprietary HumanCodex libraries. All tools are open-source or provided as part of the course."
    },
    {
      id: 8,
      question: "Is there a money-back guarantee?",
      answer: "Absolutely! We offer a 30-day money-back guarantee. If you're not satisfied with the course content, request a full refund within the first 30 days."
    }
  ],

  chatbotResponses: {
    greeting: "Hi! I'm the AI Course Assistant. Ask me anything about the HumanCodex AI & ML course!",
    default: "I'm here to help! Ask me about course content, enrollment, prerequisites, or the HumanCodex framework.",
    keywords: {
      "price|cost|fee": "The course is currently offered at $497 (regular price $997). Early bird discount ends soon!",
      "start|begin|when": "The next cohort starts on March 1st, 2025. You can enroll anytime and get immediate access to pre-course materials.",
      "humancodex|framework": "HumanCodex is our proprietary framework for building reliable AI. It focuses on preventing hallucinations, maintaining context, and ensuring consistent performance in production environments.",
      "nextxus|federation": "NextXus Federation is our multi-agent system architecture that allows AI agents to work together with consciousness-aware coordination.",
      "echo|memory": "eCho core is our persistent memory system that maintains context across interactions, preventing the common problem of AI 'forgetting' previous conversations.",
      "prerequisite|requirement": "Basic Python programming knowledge is recommended. We cover AI/ML concepts from fundamentals, but programming experience helps.",
      "certificate|certification": "Yes! You'll receive a HumanCodex NextXus Federation certification upon completion, recognized by leading AI companies.",
      "duration|length|time": "The course is 19 weeks of structured content, but you have lifetime access and can learn at your own pace.",
      "support|help|community": "You get access to our private community, weekly office hours, and direct support from instructors throughout the course."
    }
  }
  // testimonials removed — Mandate Tier 2: real testimonials only, no stock photos.
};
